import Seo from '@/components/Seo';
import { useAdSuppression } from '@/hooks/useAdSuppression';

export default function TermsPage() {
    useAdSuppression();
    return (
        <>
            <Seo
                title="Terms of Service"
                description="The terms that govern your use of UtilityTool."
                canonical="/terms-of-service"
            />
            <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-16">
                <p className="text-sm text-slate-500">Legal</p>
                <h1 className="mt-1 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Terms of Service
                </h1>
                <p className="mt-2 text-slate-500 text-sm">Last updated: January 1, 2026</p>
                <div className="prose mt-6">
                    <p>
                        These Terms of Service (“Terms”) govern your access to and use of
                        UtilityTool, a collection of online utility tools (the “Service”),
                        operated by UtilityTool, based at Route 82 Security Apartments,
                        Unit 34, Vereeniging Rd, Olifantsvlei 327-Iq, Johannesburg South,
                        2091, South Africa. By using the Service, you agree to be bound
                        by these Terms.
                    </p>
                    <h2>Eligibility</h2>
                    <p>
                        You may use the Service only if you can form a binding contract with
                        us and only in compliance with these Terms and all applicable local,
                        state, national, and international laws, rules, and regulations.
                    </p>
                    <h2>Acceptable use</h2>
                    <p>
                        You agree not to use the Service to upload, process, or distribute any
                        content that:
                    </p>
                    <ul>
                        <li>Violates any law or third-party right, including copyright.</li>
                        <li>Contains malware, viruses, or other harmful code.</li>
                        <li>Is intended to harass, defame, or harm any person.</li>
                        <li>
                            Attempts to overwhelm, disrupt, or reverse-engineer our
                            infrastructure.
                        </li>
                    </ul>
                    <p>
                        We reserve the right, but not the obligation, to block or restrict
                        access to the Service for anyone who violates these rules.
                    </p>
                    <h2>Your content</h2>
                    <p>
                        You retain all rights to the files you upload to the Service. We do
                        not claim ownership of your content. We only use your uploaded files
                        to perform the conversion or processing you have requested, and we
                        delete them immediately after processing, as described in our Privacy
                        Policy.
                    </p>
                    <h2>No warranty</h2>
                    <p>
                        The Service is provided “as is”, without warranty of any kind, either
                        express or implied. We do not guarantee that the Service will be
                        uninterrupted, error-free, or fit for a particular purpose. Always
                        keep a backup of any file you convert.
                    </p>
                    <h2>Limitation of liability</h2>
                    <p>
                        To the maximum extent permitted by law, we are not liable for any
                        indirect, incidental, special, consequential, or punitive damages, or
                        any loss of profits or revenues, arising from your use of the Service.
                    </p>
                    <h2>Advertising</h2>
                    <p>
                        The Service is supported by advertising. Advertisements shown are the
                        responsibility of the respective advertiser. We do not endorse any
                        product or service advertised on our pages.
                    </p>
                    <h2>Termination</h2>
                    <p>
                        We may suspend or terminate your access to the Service at any time,
                        with or without notice, if we believe you have violated these Terms.
                    </p>
                    <h2>Changes to the Terms</h2>
                    <p>
                        We may modify these Terms from time to time. If we make material
                        changes, we will update the “Last updated” date. Continued use of the
                        Service after such changes constitutes your acceptance of the updated
                        Terms.
                    </p>
                    <h2>Governing law</h2>
                    <p>
                        These Terms are governed by the laws of the Republic of South
                        Africa. Any dispute arising from these Terms or your use of the
                        Service will be subject to the exclusive jurisdiction of the
                        courts of South Africa.
                    </p>

                    <h2>Contact</h2>
                    <p>
                        If you have questions about these Terms, please email{' '}
                        <a href="mailto:hello@utilitytool.co.za">hello@utilitytool.co.za</a>,
                        or write to UtilityTool at Route 82 Security Apartments, Unit 34,
                        Vereeniging Rd, Olifantsvlei 327-Iq, Johannesburg South, 2091,
                        South Africa.
                    </p>
                </div>
            </section>
        </>
    );
}
